<template>
  <div>

    <Head title="Create Connector" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/connectors">Connectors</Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-5xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full" label="Title" />
          <select-input v-model="form.type" :error="form.errors.type" class="pb-8 pr-6 w-full" label="Type"
            :disabled="isContinue ? true : false">
            <option :value="null" />
            <option value="import">Import</option>
            <option value="export">Export</option>
          </select-input>

          <!-- Import -->
          <div class="w-full" v-if="form.type == 'import'">
            <select-input v-model="form.source" :error="form.errors.source" class="pb-8 pr-6 w-full" label="Source"
              :disabled="isContinue ? true : false">
              <option :value="null" />
              <option value="euronics">Euronics</option>
            </select-input>
            <div class="w-full">
              <select-input v-model="form.destination" :error="form.errors.destination" class="pb-8 pr-6 w-full"
                label="Destination" :disabled="isContinue ? true : false">
                <option :value="null" />
                <option value="shopify">Shopify</option>
                <option value="magento">Magento</option>
              </select-input>
              <div class="flex flex-wrap w-full" v-if="form.destination == 'shopify'">
                <text-input v-model="form.destination_json.shop_domain" :error="form.errors.destination_json"
                  class="pb-8 pr-6 w-full lg:w-1/2" label="Shop Domain" />
                <text-input v-model="form.destination_json.api_access_token" :error="form.errors.destination_json"
                  class="pb-8 pr-6 w-full lg:w-1/2" label="Api Access Token" />
              </div>
              <div class="flex flex-wrap w-full" v-if="form.destination == 'magento'">
                <text-input v-model="form.destination_json.api_url" :error="form.errors.destination_json"
                  class="pb-8 pr-6 w-full lg:w-1/2" label="API Url" />
                <text-input v-model="form.destination_json.api_access_token" :error="form.errors.destination_json"
                  class="pb-8 pr-6 w-full lg:w-1/2" label="API Access Token" />
              </div>
            </div>
            <select-input v-model="form.shop" :error="form.errors.shop" class="pb-8 pr-6 w-full" label="Shop"
              :disabled="isContinue ? true : false">
              <option :value="null" />
              <option value="elsalg">Elsalg</option>
              <option value="euronics">Euronics</option>
              <option value="vores">Vores</option>
              <option value="lyspunkt">Lyspunkt</option>
              <option value="photocare">Photocare</option>
              <option value="lysmesteren">Lysmesteren</option>
            </select-input>
            <select-input v-model="form.import_type" :error="form.errors.import_type" class="pb-8 pr-6 w-full"
              label="Import Type" :disabled="isContinue ? true : false">
              <option :value="null" />
              <option value="full">Full</option>
              <option value="partial">Partial</option>
              <option value="delta">Delta</option>
            </select-input>
            <div class="flex pb-8 pr-6 w-full" v-if="form.destination == 'shopify'">
              <label class="form-label" for="accept">Enable FeatureLines Mapping</label>
              <input type="checkbox" v-model="form.is_filter" class="ml-5" :disabled="isContinue ? true : false" />
            </div>
          </div>

          <!-- Export -->
          <div class="w-full" v-if="form.type == 'export'">
            <select-input v-model="form.source" :error="form.errors.source" class="pb-8 pr-6 w-full" label="Source"
              :disabled="isContinue == true ? true : false">
              <option :value="null" />
              <option value="shopify">Shopify</option>
            </select-input>
            <div class="flex flex-wrap w-full" v-if="form.source == 'shopify'">
              <text-input v-model="form.source_json.shop_domain" class="pb-8 pr-6 w-full lg:w-1/2"
                label="Shop Domain" />
              <text-input v-model="form.source_json.api_access_token" class="pb-8 pr-6 w-full lg:w-1/2"
                label="Api Access Token" />
              <select-input v-model="form.source_json.export" :error="form.errors.source_json"
                class="pb-8 pr-6 w-full lg:w-1/2" label="Export" :disabled="isContinue == true ? true : false">
                <option :value="null" />
                <option value="products">Products</option>
                <option value="customers">Customers</option>
                <option value="orders">Orders</option>
              </select-input>
              <select-input v-model="form.destination" :error="form.errors.destination"
                class="pb-8 pr-6 w-full lg:w-1/2" label="Destination" :disabled="isContinue == true ? true : false">
                <option :value="null" />
                <option value="xml">XML</option>
                <option value="csv">CSV</option>
                <option v-if="form.source_json.export != 'products'" value="webservice">Webservice</option>
              </select-input>
            </div>
          </div>

          <LoadingBar class="flex items-center justify-center pb-8 w-full" v-if="isLoading" />

          <div class="pb-8 pr-6 w-full text-right" v-if="!isContinue && !isLoading">
            <span class="btn-indigo cursor-pointer"
              v-if="form.destination != 'webservice' || form.source_json.export == 'products'"
              @click="getItemFields">Continue</span>
            <div v-if="form.destination == 'webservice' && form.source_json.export != 'products'">
              <loading-button :loading="form.processing" class="btn-indigo cursor-pointer" type="submit">Create
                Connector</loading-button>
            </div>
          </div>

          <!-- Error message -->
          <div class="items-center pb-8 pr-6 w-full" v-if="message">
            <div class="flex items-center justify-between bg-red-500 rounded">
              <div class="flex items-center">
                <svg class="flex-shrink-0 ml-4 mr-2 w-4 h-4 fill-white" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20">
                  <path
                    d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm1.41-1.41A8 8 0 1 0 15.66 4.34 8 8 0 0 0 4.34 15.66zm9.9-8.49L11.41 10l2.83 2.83-1.41 1.41L10 11.41l-2.83 2.83-1.41-1.41L8.59 10 5.76 7.17l1.41-1.41L10 8.59l2.83-2.83 1.41 1.41z" />
                </svg>
                <div class="py-4 text-white text-sm font-medium">{{ message }}</div>
              </div>
            </div>
          </div>

          <!-- Filter Mapping -->
          <div class="flex flex-wrap w-full" v-if="filterFields != null && typeof featurelineFields == 'object'">
            <div class="pb-4 pr-6 w-full">FeatureLine Fields Mapping :</div>
            <div class="form-input flex flex-wrap mb-6 mr-6 pr-6 w-full">
              <label class="form-label mt-2 pb-4 pl-2"
                v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">Source:</label>
              <label class="form-label mt-2 pb-4 pl-2"
                v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">Destination:</label>
              <label v-if="form.destination === 'magento'" class="form-label mt-2 pb-4 pl-2"
                v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">Type:</label>
              <div v-for="(input, index) in filter_mapping_json" :key="`jsonInput-${index}`"
                class="input wrapper -center flex items-center mb-3 pb-5 w-full">
                <div class="mr-2 h-10 rounded-lg outline-none"
                  v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">
                  <select v-if="level3Shops.includes(form.shop)" v-model="input.source" class="form-select">
                    <option></option>
                    <option v-for="(filterField, filterIndex) in filterFields" :key="filterIndex" :value="filterIndex">
                      {{ filterField }}
                    </option>
                  </select>
                  <select v-else v-model="input.source" class="form-select">
                    <option></option>
                    <option v-for="filterField in filterFields" :key="filterField" :value="filterField">{{ filterField
                      }}
                    </option>
                  </select>
                </div>
                <div class="mr-2 h-10 rounded-lg outline-none"
                  v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">
                  <text-input v-model="input.destination" />
                </div>
                <div class="mr-2 h-10 rounded-lg outline-none" v-if="form.destination === 'magento'"
                  v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">
                  <select v-model="input.type" class="form-select">
                    <option value="text" selected>Text</option>
                    <option value="select">Dropdown</option>
                    <option v-if="level3Shops.includes(form.shop)" value="number">number</option>
                  </select>
                </div>
                <icon name="plus" @click="addField(input, filter_mapping_json, 'filter_mapping_json')" />
                <icon name="remove" v-show="filter_mapping_json.length > 1"
                  @click="removeField(index, filter_mapping_json)" />
              </div>
              <div v-if="filterError" class="form-error mb-3 w-full text-center">{{ filterError }}</div>
              <div v-if="form.destination == 'shopify'" class="mb-3 w-full text-left text-black font-light">
                <span><span class="font-normal">*Note :</span> Before import we need to manually create product
                  metafield
                  definitions for " </span>
                <span>{ destination }</span>
                <span>"</span>
                <div class="pt-2 w-full">
                  <span class="w-full font-normal">How to create definition ? </span>
                  <div class="pl-6 w-full">1. Create definition
                    "https://{shop-name}.myshopify.com/admin/metafields/product/create"</div>
                  <div class="pl-6 w-full">2. Name : {destination}</div>
                  <div class="pl-6 w-full">3. Namespace and key : FeatureLine.{destination} (Ex. FeatureLine.Brand)
                  </div>
                  <div class="pl-6 w-full">4. Give access to Storefront API requests</div>
                  <div class="pl-6 w-full">5. Content Type : Text(Single-line-text)</div>
                </div>
                <div class="pt-2 w-full">That's All, Add this definition to filter
                  "https://{shop-name}.myshopify.com/admin/menus"</div>
              </div>
            </div>
          </div>

          <div v-if="featurelineFields && typeof featurelineFields == 'object' && level3Shops.includes(form.shop)"
            class="pb-8 pr-6 w-full">
            <lable class="form-label">Select JSON Featureline Fields :</lable>
            <ul class="flex flex-wrap form-input w-full">
              <li class="mt-1 mb-1 lg:w-1/3 pl-8" v-for="(featurelineField, featurelineFieldIndex) in featurelineFields"
                :key="featurelineFieldIndex">
                <input type="checkbox" :value="featurelineFieldIndex" v-bind:id="featurelineFieldIndex"
                  v-model="form.store_featureline_fields" />
                {{ featurelineField }}
              </li>
            </ul>
          </div>

          <!-- Custom metafield Mapping -->
          <div v-if="form.type == 'import' && sourceItemFields != null" class="w-full">
            <div class="pb-4 pr-6 w-full">Custom Metafields Mapping :</div>
            <div class="form-input flex flex-wrap mb-6 mr-6 pr-6 w-full">
              <label class="form-label mt-2 pb-4 pl-2"
                v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">Source:</label>
              <label class="form-label mt-2 pb-4 pl-2"
                v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">Destination:</label>
              <label v-if="form.destination === 'magento'" class="form-label mt-2 pb-4 pl-2"
                v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">Type:</label>
              <div v-for="(input, index) in custom_metafield_json" :key="`jsonInput-${index}`"
                class="input wrapper -center flex items-center mb-3 pb-5 w-full">
                <div class="mr-2 h-10 rounded-lg outline-none"
                  v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">
                  <select v-model="input.source" class="form-select">
                    <option></option>
                    <option v-for="sourceItemField in sourceItemFields" :key="sourceItemField" :value="sourceItemField">
                      {{
        sourceItemField }}</option>
                  </select>
                </div>
                <div class="mr-2 h-10 rounded-lg outline-none"
                  v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">
                  <text-input v-model="input.destination" />
                </div>
                <div class="mr-2 h-10 rounded-lg outline-none" v-if="form.destination === 'magento'"
                  v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">
                  <select v-model="input.type" class="form-select">
                    <option value="text" selected>Text</option>
                    <option value="select">Dropdown</option>
                  </select>
                </div>
                <icon name="plus" @click="addField(input, custom_metafield_json, 'custom_metafield_json')" />
                <icon name="remove" v-show="custom_metafield_json.length > 1"
                  @click="removeField(index, custom_metafield_json)" />
              </div>
              <div v-if="form.destination == 'shopify'" class="w-full mb-3 text-left text-black font-light">
                <span><span class="font-normal">*Note :</span> Before import we need to manually create product
                  metafield
                  definitions for " </span>
                <span>{ destination }</span>
                <span>"</span>
                <div class="w-full pt-2">
                  <span class="w-full font-normal">How to create definition ? </span>
                  <div class="w-full pl-6">1. Create definition
                    "https://{shop-name}.myshopify.com/admin/metafields/product/create"</div>
                  <div class="w-full pl-6">2. Name : {destination}</div>
                  <div class="w-full pl-6">3. Namespace and key : FeatureLine.{destination} (Ex. FeatureLine.Brand)
                  </div>
                  <div class="w-full pl-6">4. Give access to Storefront API requests</div>
                  <div class="w-full pl-6">5. Content Type : Text(Single-line-text)</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Image Url and Identifier -->
          <div class="flex flex-wrap w-full" v-if="sourceItemFields != null && form.type == 'import'">
            <div class="pb-4 pr-6 w-full">Image :</div>
            <div class="form-input mb-6 mr-6 pb-8 pr-6 w-full">
              <div class="input wrapper -center flex items-center mb-3 pb-5 w-full">
                <div class="mr-2 w-1/2 h-10 rounded-lg outline-none">
                  <text-input v-model="form.image_url" :error="form.errors.image_url" label="Image URL" />
                </div>
                <div class="mr-2 w-1/2 h-10 rounded-lg outline-none">
                  <select-input v-model="form.image_identifier" :error="form.errors.image_identifier"
                    label="Image Identifier">
                    <option :value="null" />
                    <option v-for="sourceItemField in sourceItemFields" :key="sourceItemField" :value="sourceItemField">
                      {{
        sourceItemField }}</option>
                  </select-input>
                </div>
              </div>
            </div>
          </div>

          <!-- Source Primary Key -->
          <div class="flex flex-wrap w-full" v-if="sourceItemFields != null && form.type == 'import'">
            <div class="pb-4 pr-6 w-full">Source Primary Key :</div>
            <div class="form-input mb-6 mr-6 pb-8 pr-6 w-full">
              <div class="input wrapper -center flex items-center mb-3 pb-5 w-full">
                <div class="mr-2 w-full h-10 rounded-lg outline-none">
                  <select-input v-model="form.source_primary_key" :error="form.errors.source_primary_key"
                    label="Source">
                    <option :value="null" />
                    <option v-for="sourceItemField in sourceItemFields" :key="sourceItemField" :value="sourceItemField">
                      {{
        sourceItemField }}</option>
                  </select-input>
                </div>
              </div>
            </div>
          </div>

          <!-- Product Mapping -->
          <div class="flex flex-wrap w-full" v-if="sourceItemFields != null">
            <div class="pb-4 pr-6 w-full" v-if="form.type == 'import'">Product Fields Mapping :</div>
            <div class="pb-4 pr-6 w-full" v-if="form.type == 'export'">Fields Mapping :</div>
            <div class="form-input flex flex-wrap mb-6 mr-6 pr-6 w-full">
              <label class="form-label mt-2 pb-4 pl-2 w-1/2">Source:</label>
              <label class="form-label mt-2 pb-4 pl-2 w-1/2">Destination:</label>
              <div v-for="(input, index) in mapping_json" :key="`jsonInput-${index}`"
                class="input wrapper -center flex items-center mb-3 pb-5 w-full">
                <div class="mr-2 w-1/2 h-10 rounded-lg outline-none">
                  <select v-model="input.source" class="form-select">
                    <option></option>
                    <option v-for="sourceItemField in sourceItemFields" :key="sourceItemField" :value="sourceItemField">
                      {{
        sourceItemField }}</option>
                  </select>
                </div>
                <div class="mr-2 w-1/2 h-10 rounded-lg outline-none">
                  <select v-model="input.destination" class="form-select" v-if="form.type == 'import'">
                    <option></option>
                    <option v-for="destinationItemField in destinationItemFields" :key="destinationItemField"
                      :value="destinationItemField">{{ destinationItemField }}</option>
                  </select>
                  <text-input v-model="input.destination" v-if="form.type == 'export'" />
                </div>
                <icon name="plus" @click="addField(input, mapping_json, 'mapping_json')" />
                <icon name="remove" v-show="mapping_json.length > 1" @click="removeField(index, mapping_json)" />
              </div>
              <div v-if="itemError" class="form-error mb-3 w-full text-center">{{ itemError }}</div>
            </div>
          </div>

          <!-- Category Mapping -->
          <div class="w-full" v-if="form.type == 'import' && sourceCategoryFields != null">
            <div class="flex-wrape flex w-full">
              <div class="flex-wrape flex pb-4 w-1/2">
                <input type="radio" name="category-mapping" id="category-automatic" value="1"
                  v-model="form.category_automatic_mapping" />
                <div class="pl-2 w-full">Category Automatic Mapping</div>
              </div>
              <div class="flex-wrape flex pb-4 w-1/2">
                <input type="radio" name="category-mapping" id="category-manually" value="0"
                  v-model="form.category_automatic_mapping" />
                <div class="pl-2 w-full">Category Manually Mapping</div>
              </div>
            </div>
            <div class="flex flex-wrap w-full" v-if="form.category_automatic_mapping == 1">
              <div class="form-input flex flex-wrap mb-6 mr-6 pr-6 w-full">
                <label class="form-label mt-2 pb-4 pl-2 w-1/2">Source:</label>
                <label class="form-label mt-2 pb-4 pl-2 w-1/2">Destination:</label>
                <div v-for="(input, index) in category_mapping_json" :key="`jsonInput-${index}`"
                  class="input wrapper -center flex items-center mb-3 pb-5 w-full">
                  <div class="mr-2 w-1/2 h-10 rounded-lg outline-none">
                    <select v-model="input.source" class="form-select">
                      <option></option>
                      <option v-for="sourceCategoryField in sourceCategoryFields" :key="sourceCategoryField"
                        :value="sourceCategoryField">{{ sourceCategoryField }}</option>
                    </select>
                  </div>
                  <div class="mr-2 w-1/2 h-10 rounded-lg outline-none">
                    <select v-model="input.destination" class="form-select" v-if="form.type == 'import'">
                      <option></option>
                      <option v-for="destinationCategoryField in destinationCategoryFields"
                        :key="destinationCategoryField" :value="destinationCategoryField">{{ destinationCategoryField }}
                      </option>
                    </select>
                    <text-input v-model="input.destination" v-if="form.type == 'export'" />
                  </div>
                  <icon name="plus" @click="addField(input, category_mapping_json, 'category_mapping_json')" />
                  <icon name="remove" v-show="category_mapping_json.length > 1"
                    @click="removeField(index, category_mapping_json)" />
                </div>
                <div v-if="categoryError" class="form-error mb-3 w-full text-center">{{ categoryError }}</div>
              </div>
            </div>
            <div class="flex flex-wrap w-full" v-if="form.category_automatic_mapping == 0">
              <div class="form-input flex flex-wrap mb-6 mr-6 pr-6 w-full">
                <label class="form-label mt-2 pb-4 pl-2 w-1/2">Source:</label>
                <label class="form-label mt-2 pb-4 pl-2 w-1/2">Destination:</label>
                <div v-for="(input, index) in category_manually_mapping_json" :key="`jsonInput-${index}`"
                  class="input wrapper -center flex items-center mb-3 pb-5 w-full">
                  <div class="mr-2 w-1/2 h-10 rounded-lg outline-none">
                    <text-input v-model="input.source" />
                  </div>
                  <div class="mr-2 w-1/2 h-10 rounded-lg outline-none">
                    <text-input v-model="input.destination" />
                  </div>
                  <icon name="plus"
                    @click="addField(input, category_manually_mapping_json, 'category_manually_mapping_json')" />
                  <icon name="remove" v-show="category_manually_mapping_json.length > 1"
                    @click="removeField(index, category_manually_mapping_json)" />
                </div>
                <div v-if="categoryError" class="form-error mb-3 w-full text-center">{{ categoryError }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="sourceItemFields != null">
          <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
            <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create
              Connector</loading-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import axios from 'axios'
import Icon from '@/Shared/Icon'
import LoadingBar from '@/Shared/LoadingBar'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    Icon,
    LoadingBar,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        title: null,
        source: null,
        source_json: {},
        destination: null,
        destination_json: {},
        shop: null,
        type: null,
        import_type: null,
        image_url: null,
        image_identifier: null,
        mapping_json: null,
        category_automatic_mapping: 1,
        category_mapping_json: null,
        category_manually_mapping_json: null,
        source_primary_key: null,
        is_filter: false,
        filter_mapping_json: null,
        custom_metafield_json: null,
        store_featureline_fields: []
      }),

      allShops: ['euronics', 'elsalg', 'vores', 'lyspunkt', 'photocare', 'lysmesteren'],
      level1Shops: ['euronics', 'vores', 'lyspunkt', 'photocare', 'lysmesteren'],
      level3Shops: ['elsalg'],

      itemJson: {},
      message: null,

      filterMsg: [],

      sourceItemFields: null,
      sourceCategoryFields: null,
      destinationItemFields: null,
      destinationCategoryFields: null,
      filterFields: null,
      featurelineFields: null,

      mapping_json: [{ source: '', destination: '' }],
      category_mapping_json: [{ source: '', destination: '' }],
      category_manually_mapping_json: [{ source: '', destination: '' }],
      filter_mapping_json: [{ source: '', destination: '', type: 'text' }],
      custom_metafield_json: [{ source: '', destination: '', type: 'text' }],

      isContinue: false,
      itemError: null,
      categoryError: null,
      filterError: null,

      isLoading: false,
    }
  },
  methods: {
    store() {
      let itemJson = {}
      let categoryJson = {}
      let categoryManuallyJson = {}
      let filterJson = {}
      let metafieldJson = {}

      this.mapping_json.forEach((element) => {
        if (element.source && element.destination) {
          let data = {
            [element.source]: element.destination,
          }
          Object.assign(itemJson, data)
        }
      })

      this.category_mapping_json.forEach((element) => {
        if (element.source && element.destination) {
          let data = {
            [element.source]: element.destination,
          }
          Object.assign(categoryJson, data)
        }
      })

      this.category_manually_mapping_json.forEach((element) => {
        if (element.source && element.destination) {
          let data = {
            [element.source]: element.destination,
          }
          Object.assign(categoryManuallyJson, data)
        }
      })

      if (this.form.destination === 'magento') {
        this.filter_mapping_json.forEach((element) => {
          if (element.source && element.destination) {
            let data = {
              [element.source]: {
                key: element.destination,
                type: element.type,
              },
            }
            Object.assign(filterJson, data)
          }
        })
      } else {
        this.filter_mapping_json.forEach((element) => {
          if (element.source && element.destination) {
            let data = {
              [element.source]: element.destination,
            }
            Object.assign(filterJson, data)
          }
        })
      }

      if (this.form.destination === 'magento') {
        this.custom_metafield_json.forEach((element) => {
          if (element.source && element.destination) {
            let data = {
              [element.source]: {
                key: element.destination,
                type: element.type,
              },
            }
            Object.assign(metafieldJson, data)
          }
        })
      } else {
        this.custom_metafield_json.forEach((element) => {
          if (element.source && element.destination) {
            let data = {
              [element.source]: element.destination,
            }
            Object.assign(metafieldJson, data)
          }
        })
      }

      if (this.form.destination === 'magento') {
        this.form.is_filter = true;
      }

      this.form.mapping_json = JSON.stringify(itemJson, null, 2)
      this.form.category_mapping_json = JSON.stringify(categoryJson, null, 2)
      this.form.category_manually_mapping_json = JSON.stringify(categoryManuallyJson, null, 2)
      this.form.filter_mapping_json = JSON.stringify(filterJson, null, 2)
      this.form.custom_metafield_json = JSON.stringify(metafieldJson, null, 2)
      this.form.destination_json = JSON.stringify(this.form.destination_json, null, 2)
      this.form.source_json = JSON.stringify(this.form.source_json, null, 2)

      this.form.post('/connectors')
    },
    async getItemFields() {
      this.form.errors.source = null
      this.form.errors.destination = null
      this.form.errors.shop = null
      this.form.errors.import_type = null

      if (this.form.source == null || this.form.destination == null) {
        if (this.form.source == null) {
          this.form.errors.source = 'please select source'
        } else if (this.form.destination == null) {
          this.form.errors.destination = 'please select destination'
        }
      } else if (this.form.type == 'import' && (this.form.shop == null || this.form.import_type == null)) {
        if (this.form.shop == null) {
          this.form.errors.shop = 'please select shop'
        } else if (this.form.import_type == null) {
          this.form.errors.import_type = 'please select import type'
        }
      } else if (this.form.type == 'export' && this.form.source_json.export == null) {
        this.form.errors.source_json = 'please select export.'
      } else {
        this.isContinue = true
        this.isLoading = true
        await axios
          .post('/connectors/items', { type: this.form.type, import_type: this.form.import_type, source: this.form.source, destination: this.form.destination, shop: this.form.shop, export: this.form.source_json.export, is_filter: this.form.destination === 'magento' ? true : this.form.is_filter })
          .then(async (response) => {
            if (!response.data.message) {
              this.sourceItemFields = response.data.source_item_fields
              this.sourceCategoryFields = response.data.source_category_fields
              this.destinationItemFields = response.data.destination_item_fields
              this.destinationCategoryFields = response.data.destination_category_fields
              if (this.level1Shops.includes(this.form.shop)) {
                this.filterFields = response.data.filter_fields
              } else {
                this.filterFields = response.data.featureline_fields
              }
              this.featurelineFields = response.data.featureline_fields
              this.isContinue = true
              this.isLoading = false
              this.message = null

              if (this.sourceCategoryFields != null && this.sourceCategoryFields.length) {
                if (this.allShops.includes(this.form.shop)) {
                  this.category_mapping_json = []
                  let defaultCatMapping = this.form.destination === 'shopify' ? '{"Category_ID": "ID", "Category_Name": "collection_title", "Category_Language": "collection_body_html", "Category_ParentID": "collection_parentId"}' : '{"Category_ID": "ID", "Category_Name": "category_name", "Category_ParentID": "category_parent_id"}'
                  let categoryObj = JSON.parse(defaultCatMapping)
                  for (let i = 0; i < Object.keys(categoryObj).length; i++) {
                    let source = Object.keys(categoryObj)[i]
                    let destination = categoryObj[source]
                    let newCategoryObj = {
                      source: source,
                      destination: destination,
                    }
                    this.category_mapping_json.push(newCategoryObj)
                  }
                }
              }
              if (this.sourceItemFields != null && this.sourceItemFields.length && this.destinationItemFields) {
                this.mapping_json = []
                let defaultMapping = '';
                if (this.level3Shops.includes(this.form.shop)) {
                  defaultMapping = this.form.destination === 'magento' ? '{"Item_ItemNo": "product_sku", "Item_Inventory": "product_extension_attributes_stock_item_qty", "Item_Category_No": "product_extension_attributes_category_links", "Item_elsProductText": "product_description", "Item_UnitPriceInclTax": "product_price", "Item_elsProductShortText": "product_short_description", "Item_PartnerNetInfo_piItemName": "product_name", "Item_PartnerNetInfo_piItemStatus": "product_status"}' : '{"Item_ItemNo": "product_variants_sku", "Item_Inventory": "product_variants_inventory_quantity", "Item_Category_No": "product_collections", "Item_UnitPriceInclTax": "product_variants_price", "Item_FeatureLine_Value": "product_featureline_metafield_value", "Item_FeatureLine_Header": "product_featureline_metafield_name", "Item_elsCostCalcHandling": "product_variants_inventory_cost", "Item_elsProductShortText": "product_body_html", "Item_PartnerNetInfo_piItemName": "product_title", "Item_PartnerNetInfo_piItemStatus": "product_status"}';
                } else {
                  defaultMapping = this.form.destination === 'magento' ? '{"Item_ItemNo": "product_sku", "Item_Inventory": "product_extension_attributes_stock_item_qty", "Item_Category_No": "product_extension_attributes_category_links", "Item_elsProductText": "product_description", "Item_UnitPriceInclTax": "product_price", "Item_PartnerNetInfo_piItemName": "product_name", "Item_PartnerNetInfo_piItemStatus": "product_status"}' : '{"Item_ItemNo": "product_variants_sku", "Item_Inventory": "product_variants_inventory_quantity", "Item_Category_No": "product_collections", "Item_UnitPriceInclTax": "product_variants_price", "Item_FeatureLine_Value": "product_featureline_metafield_value", "Item_FeatureLine_Header": "product_featureline_metafield_name", "Item_elsCostCalcHandling": "product_variants_inventory_cost", "Item_elsProductShortText": "product_body_html", "Item_PartnerNetInfo_piItemName": "product_title", "Item_PartnerNetInfo_piItemStatus": "product_status"}';
                }
                if (defaultMapping) {
                  let productObj = JSON.parse(defaultMapping)
                  for (let i = 0; i < Object.keys(productObj).length; i++) {
                    let source = Object.keys(productObj)[i]
                    let destination = productObj[source]
                    let newProductObj = {
                      source: source,
                      destination: destination,
                    }
                    this.mapping_json.push(newProductObj)
                  }
                }
              }
              if (this.sourceItemFields != null && this.sourceItemFields.length && this.form.destination === 'magento') {
                if (this.allShops.includes(this.form.shop)) {
                  this.custom_metafield_json = []
                  let defaultCustomMapping = '';
                  if (this.level3Shops.includes(this.form.shop)) {
                    defaultCustomMapping = '{"Item_ItemNo": {"key": "Varenummer", "type": "text"}, "Item_elsEAN": {"key": "EAN", "type": "text"}, "Item_Prismatch": {"key": "Prismatch", "type": "text"}, "Item_elsAssortmentId": {"key": "Assortment Id", "type": "text"}, "Item_elsDeliveryText": {"key": "Delivery Text", "type": "text"}, "Item_elsOnlySoldInStore": {"key": "Only Sold In Store", "type": "text"}, "Item_PartnerNetInfo_piModel": {"key": "Model Number", "type": "text"}}';
                  } else {
                    defaultCustomMapping = '{"Item_ItemNo": {"key": "Varenummer", "type": "text"}, "Item_elsEAN": {"key": "EAN", "type": "text"}, "Item_Prismatch": {"key": "Prismatch", "type": "text"}, "Item_elsDeliveryText": {"key": "Delivery Text", "type": "text"}, "Item_elsOnlySoldInStore": {"key": "Only Sold In Store", "type": "text"}}';
                  }
                  if (defaultCustomMapping) {
                    let customObj = JSON.parse(defaultCustomMapping)
                    for (let i = 0; i < Object.keys(customObj).length; i++) {
                      let source = Object.keys(customObj)[i]
                      let destination = customObj[source]['key']
                      let type = customObj[source]['type']
                      let newCustomObj = {
                        source: source,
                        destination: destination,
                        type: type,
                      }
                      this.custom_metafield_json.push(newCustomObj)
                    }
                  }
                }
              }
              if (this.filterFields != null && this.form.destination === 'magento') {
                this.filter_mapping_json = []
                let defaultFilterMapping = null;
                if (this.level1Shops.includes(this.form.shop) && this.filterFields.length) {
                  defaultFilterMapping = '{"Mærke": {"key": "Brand","type": "select"},"Farve": {"key": "Color","type": "select"},"Designer": {"key": "Designer","type": "select"},"Produkt Diameter (cm)": {"key": "Produkt Diameter (cm)","type": "text"},"Watt": {"key": "Watt","type": "text"},"Materiale": {"key": "Materiale","type": "text"},"Energiklasse": {"key": "Energiklasse","type": "text"},"Fatning": {"key": "Fatning","type": "text"},"Indbygget Led": {"key": "Indbygget Led","type": "text"},"Indbygget Lysdæmper": {"key": "Indbygget Lysdæmper","type": "text"},"Lyskilde Medfølger": {"key": "Lyskilde Medfølger","type": "text"},"Serienavn": {"key": "Serienavn","type": "text"},"Ledning": {"key": "Ledning","type": "text"},"Lyskilde": {"key": "Lyskilde","type": "text"},"Energipil": {"key": "Energipil","type": "text"},"Ip Klasser": {"key": "Ip Klasser","type": "text"},"Ledningslængde": {"key": "Ledningslængde","type": "text"},"Højde (cm)": {"key": "Højde (cm)","type": "text"},"Bredde (cm)": {"key": "Bredde (cm) ","type": "text"},"Volt": {"key": "Volt","type": "text"}}';
                } else if (this.level3Shops.includes(this.form.shop)) {
                  await axios
                    .post('/connectors/category-facet/options', { import_type: this.form.import_type, shop: this.form.shop })
                    .then((response) => {
                      defaultFilterMapping = response.data;
                    })
                }
                if (defaultFilterMapping) {
                  let filterObj = typeof defaultFilterMapping != 'object' ? JSON.parse(defaultFilterMapping) : defaultFilterMapping
                  for (let i = 0; i < Object.keys(filterObj).length; i++) {
                    let source = Object.keys(filterObj)[i]
                    let destination = filterObj[source]['key']
                    let type = filterObj[source]['type']
                    let newFilterObj = {
                      source: source,
                      destination: destination,
                      type: type,
                    }
                    this.filter_mapping_json.push(newFilterObj)
                  }
                }
              }


              if (this.featurelineFields && typeof this.featurelineFields == 'object') {
                Object.keys(this.featurelineFields).map((value) => {
                  this.form.store_featureline_fields.push(value)
                })
              }
            } else {
              this.message = response.data.message
              this.isLoading = false
            }
          })
          .catch((error) => {
            console.error(error)
          })
      }
    },
    addField(value, fieldType, type) {
      this.itemError = null
      this.categoryError = null
      this.filterError = null
      if (value.source == '' || value.destination == '') {
        if (type == 'category_mapping_json') {
          this.categoryError = 'please select source and destination.'
        } else if (type == 'mapping_json') {
          this.itemError = 'please select source and destination.'
        } else if (type == 'filter_mapping_json') {
          this.filterError = 'please select source and destination.'
        }
      } else {
        if (this.form.destination === 'shopify' && type == 'filter_mapping_json' && fieldType.length >= 20) {
          this.filterError = 'You reached at maximum field to add.'
          return
        } else if (type == 'filter_mapping_json') {
          this.filterMsg.push(value.destination)
        }
        fieldType.push({ source: '', destination: '' })
      }
    },
    removeField(index, fieldType) {
      fieldType.splice(index, 1)
    },
  },
}
</script>
